import { Link } from "react-router-dom"

const BtnBack = () => {
  return (
    <div className="d-flex justify-content-center">
      <Link className="btn btn-primary text-white" to={process.env.PUBLIC_URL+'/'}>
        <i className="las la-angle-left"></i>Regresar
      </Link>
    </div>
  )
}

export default BtnBack